export default __webpack_public_path__ + "static/media/logo-gris.d99c37e2.png";